import { render, staticRenderFns } from "./customerSettings.vue?vue&type=template&id=ebfa1c54&scoped=true"
import script from "./customerSettings.vue?vue&type=script&lang=js"
export * from "./customerSettings.vue?vue&type=script&lang=js"
import style0 from "./customerSettings.vue?vue&type=style&index=0&id=ebfa1c54&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfa1c54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebfa1c54')) {
      api.createRecord('ebfa1c54', component.options)
    } else {
      api.reload('ebfa1c54', component.options)
    }
    module.hot.accept("./customerSettings.vue?vue&type=template&id=ebfa1c54&scoped=true", function () {
      api.rerender('ebfa1c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemManagement/customerSettings/customerSettings.vue"
export default component.exports